import type { TransactionDetailsModel } from "@/features/collections/api/models/TransactionDetailsModel";
import { useHTTP, useHTTPQueryWithCursor, type PaginatedResponseModel } from "@/lib/http";

export const useVariantTransactionDetails = (collectionId: string, variantId: string | undefined) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["transactions", collectionId, variantId],
		enabled: !!variantId,
		queryFn: ({ pageParam = 0 }) => http<PaginatedResponseModel<TransactionDetailsModel>>({
			method: "GET",
			url: `/collection/${collectionId}/transaction/variant/${variantId}?cursor=${pageParam}`
		})
	});
};
